<template>
  <div class="lp">

    <!-- ===== HERO IMAGE ===== -->
    <section class="lp-hero-img">
      <img src="@/assets/2.jpg" alt="카시아 속초 오너스 멤버십 혜택 비교" />
    </section>

    <!-- ===== CASSIA FILM (소개영상) ===== -->
    <section class="lp-section lp-film">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— C A S S I A &nbsp; F I L M —</span>
        <h2 class="lp-section-title">
          영상으로 만나는<br/>
          <em>카시아 속초</em>
        </h2>
        <div class="lp-gold-line"></div>
        <p class="film-lead">
          반얀그룹이 선보이는 동해 프리미엄 레지던스,<br/>
          <strong>카시아 속초</strong>를 영상으로 만나보세요.
        </p>

        <div class="film-frame">
          <button
            v-if="!videoPlaying"
            type="button"
            class="film-poster"
            @click="playVideo"
            aria-label="카시아 속초 소개영상 재생">
            <img src="@/assets/ext1.jpg" alt="카시아 속초 소개영상" loading="lazy" />
            <span class="film-play" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
            </span>
            <span class="film-tag">WATCH FILM</span>
          </button>
          <video
            v-else
            ref="promoVideo"
            class="film-video"
            src="@/assets/promo.mp4"
            controls
            playsinline
            preload="auto"></video>
        </div>
      </div>
    </section>

    <!-- ===== 개요 헤드 ===== -->
    <section class="lp-section lp-overview-head">
      <div class="lp-inner">
        <span class="lp-eyebrow">— B A N Y A N &nbsp; G R O U P —</span>
        <h2 class="lp-section-title">
          반얀그룹이 운영하는<br/>카시아 속초<br/>
          <em>Owners Membership</em>
        </h2>
        <div class="lp-gold-line"></div>
        <p class="head-lead">
          동해를 향해 열린 입지 위에 반얀그룹의 호스피탈리티 DNA를 담아 설계된
          <strong>럭셔리 레지던스 호텔</strong>. 투숙과 거주의 경계를 허문 새로운 라이프스타일이 이곳에서 시작됩니다.
        </p>
      </div>
    </section>

    <!-- ===== 전경 롤링 ===== -->
    <section class="lp-ovslider">
      <div class="ovs-viewport">
        <div
          class="ovs-slide"
          v-for="(src, i) in overviewSlides"
          :key="i"
          :class="{ active: activeSlide === i }">
          <img :src="src" :alt="`카시아 속초 전경 ${i + 1}`" />
        </div>
      </div>
      <div class="ovs-dots">
        <button
          v-for="(src, i) in overviewSlides"
          :key="i"
          class="ovs-dot"
          :class="{ active: activeSlide === i }"
          @click="goSlide(i)"
          :aria-label="`${i + 1}번째 전경 보기`"></button>
      </div>
    </section>

    <!-- ===== 사업 개요 데이터 ===== -->
    <section class="lp-section lp-overview">
      <div class="lp-inner">
        <dl class="ov-list">
          <div class="ov-row" v-for="(it, i) in overviewItems" :key="i">
            <dt class="ov-label">{{ it.label }}</dt>
            <dd class="ov-value" v-html="it.value"></dd>
          </div>
        </dl>
        <p class="ov-note">※ 상기 내용은 공급 및 운영 정책에 따라 변경될 수 있습니다.</p>
      </div>
    </section>

    <!-- ===== LOCATION (입지환경) ===== -->
    <section class="lp-section lp-location">
      <div class="lp-inner">
        <span class="lp-eyebrow">— L O C A T I O N —</span>
        <h2 class="lp-section-title">
          서울에서 1시간대,<br/>
          <em>동해 프리미엄 입지</em>
        </h2>
        <div class="lp-gold-line"></div>
        <p class="loc-lead">동해 푸른 바다와 설악산 전망, <strong>관광 인프라까지 고루 갖춘 입지</strong></p>

        <ul class="loc-list">
          <li class="loc-item" v-for="(it, i) in locationItems" :key="i">
            <div class="loc-head">
              <span class="loc-num">{{ it.no }}</span>
              <span class="loc-en">{{ it.en }}</span>
            </div>
            <h3 class="loc-title">{{ it.title }}</h3>
            <p class="loc-desc" v-html="it.desc"></p>
          </li>
        </ul>

        <figure class="loc-map">
          <img src="@/assets/4.jpg" alt="카시아 속초 입지 및 교통 안내도" loading="lazy" />
        </figure>
      </div>
    </section>

    <!-- ===== THE PREMIUM 7 ===== -->
    <section class="lp-section lp-premium">
      <div class="lp-inner">
        <span class="lp-eyebrow">— P R E M I U M —</span>
        <h2 class="lp-section-title">
          선택된 소수만을 위한<br/>
          <em>다섯 가지 특권</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="prem-grid">
          <article
            class="prem-card"
            :class="{ 'is-in': premiumIn.includes(i), 'prem-card-wide': i === premiumItems.length - 1 && premiumItems.length % 2 === 1 }"
            :style="{ transitionDelay: (i % 2) * 90 + 'ms' }"
            v-for="(it, i) in premiumItems"
            :key="i"
            ref="premCards">
            <figure class="prem-fig">
              <img :src="it.img" :alt="`카시아 속초 특권 ${i + 1} · ${it.title}`" loading="lazy" />
              <span class="prem-chip">{{ it.tag }}</span>
            </figure>
            <div class="prem-body">
              <h3 class="prem-title">{{ it.title }}</h3>
              <p class="prem-desc" v-html="it.desc"></p>
            </div>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== VALUE BAND (20년 실부담 0원 비교) ===== -->
    <section class="lp-section lp-value">
      <div class="lp-inner narrow center">
        <span class="lp-eyebrow light">— V A L U E —</span>
        <h2 class="lp-section-title white">
          타 5성급 회원권과<br/>
          <em>비교하세요</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="value-compare">
          <div class="value-col value-other">
            <span class="value-tag">타 5성급 호텔 회원권</span>
            <ul>
              <li><span class="vc-label">입회비</span><span class="vc-strike">1 ~ 2억</span></li>
              <li><span class="vc-label">연회비·관리비</span><span class="vc-strike">연 1,000 ~ 2,000만원</span></li>
            </ul>
          </div>
          <div class="value-vs">VS</div>
          <div class="value-col value-cassia">
            <span class="value-tag">카시아 속초 오너스 멤버십</span>
            <ul>
              <li><span class="vc-label">20년 실부담</span><span class="vc-strong">0원</span></li>
              <li><span class="vc-label">연회비·관리비</span><span class="vc-strong">0원</span></li>
            </ul>
          </div>
        </div>

        <ul class="value-guarantees">
          <li>
            <span class="vg-icon">✓</span>
            <span class="vg-text">양도·매매 시 <strong>100% 권리 영구 승계</strong></span>
          </li>
          <li>
            <span class="vg-icon">✓</span>
            <span class="vg-text">20년 만기 후 <strong>100% 전액 안전 회수 확약</strong></span>
          </li>
        </ul>

        <p class="value-foot">
          20년간 <strong>조식 · 디너 · 인피니티풀 50%</strong><br/>
          <strong>연 30박</strong> · 전 객실 <strong>50% 반값</strong>
        </p>
        <p class="value-note">※ 상기 타사 비교 내용은 공개 자료를 참조한 것으로 실제와 차이가 있을 수 있습니다.</p>
      </div>
    </section>

    <!-- ===== OWNERSHIP OFFER (현재 한정 혜택) ===== -->
    <section class="lp-section lp-offer">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— O W N E R S H I P —</span>
        <h2 class="lp-section-title">
          원금 손실 리스크 ZERO<br/>
          <em>가장 안전한 오너십</em>
        </h2>
        <div class="lp-gold-line"></div>
        <p class="offer-lead">
          양도·매매 시에도 권리가 영구 승계되는 <strong>확실한 프리미엄</strong>,<br/>
          지금 한정으로 선점하세요.
        </p>

        <ul class="offer-pillars">
          <li class="offer-pillar" v-for="(p, i) in offerPillars" :key="i">
            <div class="op-head">
              <span class="op-no">{{ p.no }}</span>
              <span class="op-en">{{ p.en }}</span>
            </div>
            <h3 class="op-title" v-html="p.title"></h3>
            <p class="op-desc" v-html="p.desc"></p>
          </li>
        </ul>

        <dl class="offer-specs">
          <div class="offer-spec" v-for="(s, i) in offerSpecs" :key="i">
            <dt>{{ s.label }}</dt>
            <dd v-html="s.value"></dd>
          </div>
        </dl>

        <div class="offer-trust">
          <span v-for="(t, i) in offerTrust" :key="i" class="offer-trust-item">{{ t }}</span>
        </div>
      </div>
    </section>

    <!-- ===== MEMBERSHIP (혜택) ===== -->
    <section class="lp-section lp-mem">
      <div class="lp-inner">
        <span class="lp-eyebrow">— M E M B E R S H I P —</span>
        <h2 class="lp-section-title">
          핵심만 담은<br/>
          <em>멤버십 혜택</em>
        </h2>
        <div class="lp-gold-line"></div>

        <p class="mem-headline"><strong>연 30박</strong> · 전 객실 <strong>50% 반값</strong></p>

        <ul class="mem-benefits">
          <li class="mem-benefit" v-for="(b, i) in memBenefits" :key="i">
            <span class="mem-benefit-name">{{ b.name }}</span>
            <span class="mem-benefit-val" v-html="b.val"></span>
          </li>
        </ul>

        <div class="comm-notes">
          <p v-for="(note, ni) in memNotes" :key="ni">※ {{ note }}</p>
        </div>
      </div>
    </section>

    <!-- ===== OCEAN VIEW SHOWCASE ===== -->
    <section class="lp-section lp-ocean">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— O C E A N &nbsp; V I E W —</span>
        <h2 class="lp-section-title">
          전 객실이 품은<br/>
          <em>동해 파노라마</em>
        </h2>
        <div class="lp-gold-line"></div>
        <p class="ocean-lead">
          발코니 · 욕조 · 주방을 갖춘 <strong>전 객실 오션뷰</strong>.<br/>
          호텔 스위트룸의 품격을 일상으로 누립니다.
        </p>

        <div class="ocean-gallery">
          <figure
            class="ocean-cell"
            :class="{ 'ocean-cell-wide': s.wide }"
            v-for="(s, i) in oceanShots"
            :key="i">
            <img :src="s.img" :alt="`카시아 속초 오션뷰 객실 ${i + 1}`" loading="lazy" />
            <figcaption v-if="s.cap" class="ocean-cap">{{ s.cap }}</figcaption>
          </figure>
        </div>

        <p class="unit-note">※ 객실 이미지는 이해를 돕기 위한 것으로 실제와 차이가 있을 수 있습니다.</p>
      </div>
    </section>

    <!-- ===== DINING & BAR ===== -->
    <section class="lp-section lp-facility lp-facility-dining">
      <div class="lp-inner">
        <span class="lp-eyebrow">— D I N I N G &nbsp; &amp; &nbsp; B A R —</span>
        <h2 class="lp-section-title">
          바다를 마주한<br/>
          <em>세계 수준의 미식</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="fac-grid">
          <article class="fac-card" v-for="(f, i) in diningItems" :key="i">
            <figure class="fac-fig">
              <img :src="f.img" :alt="`카시아 속초 ${f.name}`" loading="lazy" />
              <span class="fac-floor">{{ f.floor }}</span>
            </figure>
            <div class="fac-body">
              <h3 class="fac-name">{{ f.name }}</h3>
              <p class="fac-desc">{{ f.desc }}</p>
            </div>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== WELLNESS / 부대시설 ===== -->
    <section class="lp-section lp-facility lp-facility-wellness">
      <div class="lp-inner">
        <span class="lp-eyebrow">— W E L L N E S S —</span>
        <h2 class="lp-section-title">
          몸과 마음에 활력을 더하는<br/>
          <em>프리미엄 부대시설</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="fac-grid">
          <article class="fac-card" v-for="(f, i) in wellnessItems" :key="i">
            <figure class="fac-fig">
              <img :src="f.img" :alt="`카시아 속초 ${f.name}`" loading="lazy" />
              <span class="fac-floor">{{ f.floor }}</span>
            </figure>
            <div class="fac-body">
              <h3 class="fac-name">{{ f.name }}</h3>
              <p class="fac-desc">{{ f.desc }}</p>
            </div>
          </article>
        </div>

        <div class="comm-notes">
          <p v-for="(note, ni) in facilityNotes" :key="ni">※ {{ note }}</p>
        </div>
      </div>
    </section>

    <!-- ===== EXPERIENCE GALLERY ===== -->
    <section class="lp-section lp-landscape">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— E X P E R I E N C E —</span>
        <h2 class="lp-section-title">
          투숙과 거주의 경계를 허문<br/>
          <em>카시아 라이프</em>
        </h2>
        <div class="lp-gold-line"></div>
        <p class="land-lead">세계 수준의 서비스와 시설을 일상으로,<br/><strong>동해를 품은 새로운 휴양</strong>이 시작됩니다.</p>

        <div class="land-slider">
          <div class="land-viewport">
            <div
              class="land-slide"
              v-for="(s, i) in landscapeSlides"
              :key="i"
              :class="{ active: landscapeActive === i }">
              <img :src="s.img" :alt="`카시아 속초 ${s.caption}`" loading="lazy" />
              <span class="land-caption">{{ s.caption }}</span>
            </div>
          </div>
          <div class="land-dots">
            <button
              v-for="(s, i) in landscapeSlides"
              :key="i"
              class="land-dot"
              :class="{ active: landscapeActive === i }"
              @click="goLandscape(i)"
              :aria-label="`${s.caption} 보기`"></button>
          </div>
        </div>

        <ul class="land-list">
          <li class="land-item" v-for="(f, i) in landscapeItems" :key="i">
            <h4 class="land-item-name">{{ f.name }}</h4>
            <p class="land-item-desc">{{ f.desc }}</p>
          </li>
        </ul>
      </div>
    </section>

    <!-- ===== Q & A ===== -->
    <section class="lp-section lp-faq">
      <div class="lp-inner">
        <span class="lp-eyebrow">— Q &amp; A —</span>
        <h2 class="lp-section-title">
          궁금한 점을<br/>
          <em>모두 담았습니다</em>
        </h2>
        <div class="lp-gold-line"></div>

        <ul class="faq-list">
          <li
            class="faq-item"
            v-for="(f, i) in faqs"
            :key="i"
            :class="{ open: faqOpen.includes(i) }">
            <button class="faq-q" @click="toggleFaq(i)" :aria-expanded="faqOpen.includes(i)">
              <span class="faq-q-mark">Q</span>
              <span class="faq-q-text">{{ f.q }}</span>
              <span class="faq-chevron" aria-hidden="true"></span>
            </button>
            <div class="faq-a-wrap">
              <div class="faq-a">
                <p v-html="f.a"></p>
              </div>
            </div>
          </li>
        </ul>

        <div class="comm-notes">
          <p v-for="(note, ni) in faqNotes" :key="ni">※ {{ note }}</p>
        </div>
      </div>
    </section>

    <!-- ===== RESERVATION CTA ===== -->
    <section class="lp-section lp-cta">
      <div class="lp-inner narrow center">
        <span class="lp-eyebrow light">— R E S E R V A T I O N —</span>
        <h2 class="lp-section-title white">
          동해를 품은 단 한 번의 소유,<br/>
          <em>지금 예약하세요</em>
        </h2>
        <div class="lp-gold-line"></div>

        <p class="cta-desc">
          카시아 속초 오너스 멤버십은 <strong>철저한 예약제</strong>로 운영됩니다.<br/>
          방문 예약 시 전문 상담을 통해 자세한 멤버십 정보를 안내해 드립니다.
        </p>

        <ul class="cta-points">
          <li class="cta-point">
            <span class="cta-point-icon">✓</span>
            <span class="cta-point-text">소수 한정 <strong>프라이빗 멤버십</strong></span>
          </li>
          <li class="cta-point">
            <span class="cta-point-icon">✓</span>
            <span class="cta-point-text">1:1 <strong>프라이빗 멤버십 상담</strong></span>
          </li>
          <li class="cta-point">
            <span class="cta-point-icon">✓</span>
            <span class="cta-point-text">청담 홍보관 <strong>방문 고객 우선 안내</strong></span>
          </li>
        </ul>

        <button class="cta-btn" @click="openRegister">
          <span class="cta-btn-en">PRIVATE RESERVATION</span>
          <span class="cta-btn-kr">방문 예약하기</span>
          <span class="cta-btn-arrow">→</span>
        </button>

        <p class="cta-note">
          ※ 본 사이트는 카시아 속초 오너스 멤버십 상담 및 방문 예약 안내 페이지입니다.<br/>
          제공 혜택 및 조건은 운영 정책에 따라 변경될 수 있습니다.
        </p>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'MainView',
  data() {
    return {
      premiumItems: [
        {
          img: require('@/assets/prem1.jpg'),
          tag: 'BANYAN GROUP',
          title: '글로벌 TOP 브랜드의 품격',
          desc: '세계적 호스피탈리티 그룹 <strong>반얀그룹(Banyan Group)</strong>이<br/>운영하는 호텔을 소유하는 특별함',
        },
        {
          img: require('@/assets/prem3.jpg'),
          tag: 'ANNUAL FEE 0',
          title: '평생 연회비 면제',
          desc: '최초 가입 이후 <strong>평생 연회비·관리비 0원</strong><br/>매년 고정비용 없는 프리미엄 멤버십',
        },
        {
          img: require('@/assets/prem4.jpg'),
          tag: 'UP TO 30 NIGHTS',
          title: '연간 최대 30박',
          desc: '주중·주말·성수기까지 균형있게 설계된<br/><strong>연 30박</strong>의 하이엔드 숙박 혜택',
        },
        {
          img: require('@/assets/prem5.jpg'),
          tag: 'SUITE-LEVEL',
          title: '호텔 스위트룸의 품격',
          desc: '프리미어 전용 <strong>24평형 오션뷰</strong><br/>전 객실 바다 전망의 스위트급 공간',
        },
        {
          img: require('@/assets/prem7.jpg'),
          tag: 'F&B PRIVILEGE',
          title: '식음료·부대시설 특별 할인',
          desc: '조식·디너 뷔페 <strong>50%</strong>, 인피니티풀·사우나 <strong>50%</strong><br/>스파 <strong>20%</strong> 등 폭넓은 할인 혜택',
        },
      ],

      overviewItems: [
        { label: '현장명',   value: '카시아 속초 <span class="ov-en">CASSIA SOKCHO</span>' },
        { label: '위치',     value: '강원특별자치도 속초시 대포항희망길 120' },
        { label: '운영',     value: '반얀그룹(Banyan Group) 위탁 운영' },
        { label: '규모',     value: '<span class="ov-sub"><span class="ov-tag">객실</span><span class="ov-txt">전 객실 오션뷰 프리미엄 레지던스</span></span><span class="ov-sub"><span class="ov-tag">부대</span><span class="ov-txt">레스토랑&바 5 · 연회공간 5 · 인피니티풀 · 스파 · 피트니스</span></span>' },
        { label: '상품유형', value: '특정 객실 1/52 지분등기제 하이엔드 오너스 멤버십' },
        { label: '객실타입', value: '디럭스 · 프리미어 · 시그니처' },
      ],

      locationItems: [
        { no: '01', en: 'Access', title: '서울에서 1시간대', desc: '서울-양양고속도로 <strong>약 1시간 40분</strong>,<br/>김포-양양 노선 30분으로 빠르게 닿는 동해' },
        { no: '02', en: 'Railway', title: '2029 KTX 속초역', desc: '<strong>동서고속화철도(KTX)</strong> 속초역 개통 예정으로<br/>접근 편의성은 더욱 향상될 전망' },
        { no: '03', en: 'Nature', title: '동해와 설악을 한눈에', desc: '객실 자쿠지에서 감상하는 <strong>동해 바다</strong>와<br/>인근 설악산의 사계절 절경' },
        { no: '04', en: 'Tourism', title: '풍요로운 관광 인프라', desc: '이마트 8분·속초중앙시장 15분,<br/><strong>대포항 · 아바이마을 · 속초해변</strong> 등 즐길거리' },
      ],

      memBenefits: [
        { name: '객실', val: '회원요금 (성수기·주말 포함)' },
        { name: '조식 & 디너 뷔페', val: '<strong>50%</strong> 할인' },
        { name: '비스타·호라이즌·보스코', val: '<strong>25%</strong> 할인' },
        { name: '인피니티풀 & 사우나', val: '<strong>50%</strong> 할인' },
        { name: 'SPA by ELBRIN', val: '<strong>20%</strong> 할인' },
        { name: '연회비 · 관리비', val: '평생 <strong>0원</strong>' },
      ],
      memNotes: [
        '연간 사용일수는 매년 3월 1일 리셋되며, 미사용분은 다음 해로 이월되지 않습니다.',
        '부대시설 할인은 실물 멤버십 카드 소지 시 적용됩니다(디럭스 2인 / 프리미어·시그니처 4인 기준).',
        '할인 혜택은 호텔 운영정책에 따라 변경될 수 있으며, 프로모션 메뉴는 중복 할인이 불가합니다.',
      ],

      offerPillars: [
        { no: '01', en: 'SAFETY', title: '원금 손실 리스크 ZERO', desc: '20년 만기 시 가입 금액 <strong>100% 전액 재매입</strong> 약정으로 안전하게 회수됩니다.' },
        { no: '02', en: 'PREMIUM', title: '100% 권리 영구 승계', desc: '양도·증여·제3자 매매 시에도 <strong>동일 혜택이 그대로 승계</strong>되어, KTX 개통과 함께 프리미엄이 기대됩니다.' },
        { no: '03', en: 'VALUE', title: '평생 연회비 0원', desc: '연회비·관리비 평생 0원에 더해 <strong>하루 최대 95만원 상당</strong>의 실사용 혜택을 누립니다.' },
      ],
      offerSpecs: [
        { label: '객실 이용', value: '연 30박 · 전 객실 <strong>50% 반값</strong>' },
        { label: '뷔페 다이닝', value: '조식 + 디너 뷔페 상시 <strong>50% 반값</strong>' },
        { label: '만기 재매입', value: '20년 계약금액 <strong>100% 전액 재매입</strong>' },
        { label: '양도 승계', value: '매수인에게도 <strong>100% 권리 영구 승계</strong>' },
        { label: '자산 가치', value: '손바뀜 시 <strong>높은 프리미엄(P) 형성</strong>' },
      ],
      offerTrust: [
        '시행사 법적 매매예약 약정',
        '코람코자산신탁 안전 자금관리',
        '1/52 지분 등기제 실자산',
      ],

      oceanShots: [
        { img: require('@/assets/ocean1.jpg'), cap: '오션뷰 리빙', wide: true },
        { img: require('@/assets/room_premier.jpg'), cap: '프리미엄 스테이' },
        { img: require('@/assets/room_signature.jpg'), cap: '스위트 룸' },
        { img: require('@/assets/room_suite.jpg'), cap: '디럭스 스위트' },
        { img: require('@/assets/room_1br.jpg'), cap: '원 베드룸 스위트' },
        { img: require('@/assets/ocean2.jpg'), cap: '전 객실 바다 전망', wide: true },
      ],

      diningItems: [
        { img: require('@/assets/din_vista.jpg'), name: '비스타 VISTA', floor: 'Tower C · 4F', desc: '라이브 쿠킹 인터내셔널 뷔페. 제철 식재료로 즉석 조리하는 세계 각국의 미식을 경험합니다.' },
        { img: require('@/assets/din_horizon.jpg'), name: '호라이즌 HORIZON', floor: 'Tower B · 4F', desc: '향긋한 커피와 갓 구운 베이커리, 통창 너머 푸른 바다를 즐기는 감각적인 카페 & 베이커리.' },
        { img: require('@/assets/din_bosco.jpg'), name: '보스코 BOSCO', floor: 'Tower C · 24F', desc: '바다와 산의 파노라마를 품은 클래식 바 & 라운지. 시그니처 칵테일과 애프터눈 티.' },
        { img: require('@/assets/din_cielo.jpg'), name: '시엘로 CIELO', floor: 'Tower C · RF', desc: '최고층 루프탑 바. 바다 바람과 독창적인 칵테일, 자연과 어우러진 시크한 무드.' },
      ],
      wellnessItems: [
        { img: require('@/assets/fac_pool.jpg'), name: '인피니티풀', floor: '4F', desc: '동해와 이어진 듯한 53m 인피니티풀과 플로팅 덱, 사계절 실내수영장과 키즈풀.' },
        { img: require('@/assets/fac_bath.jpg'), name: '노천탕', floor: '5F', desc: '끊임없이 들려오는 파도 소리와 시원한 바닷바람이 함께하는 야외 노천탕.' },
        { img: require('@/assets/fac_sauna.jpg'), name: '사우나', floor: '5F', desc: '최고급 시설을 갖춘 건식·습식 사우나와 목욕시설로 피로와 긴장을 해소합니다.' },
        { img: require('@/assets/fac_spa.jpg'), name: '스파 바이 엘브린', floor: '5F', desc: '전문 테라피스트의 섬세한 맞춤형 트리트먼트, 심신의 균형을 되찾는 프리미엄 웰니스 스파.' },
        { img: require('@/assets/fac_fitness.jpg'), name: '액티바 피트니스', floor: '5F', desc: '이탈리아 명품 「테크노짐」 머신을 갖춘 24시간 프리미엄 피트니스 센터.' },
        { img: require('@/assets/fac_kids.jpg'), name: '플레이플레이 키즈카페', floor: '5F', desc: '파노라믹 오션뷰의 감성 키즈카페와 체험형 키즈 클래스.' },
      ],
      facilityNotes: [
        '상기 이미지는 소비자의 이해를 돕기 위해 제작된 것으로 실제와 차이가 있을 수 있습니다.',
        '부대시설 운영 및 이용 방침은 호텔 운영 정책에 따라 변경될 수 있습니다.',
      ],

      // 체험 갤러리
      landscapeSlides: [
        { img: require('@/assets/ocean1.jpg'), caption: '오션뷰 스위트' },
        { img: require('@/assets/fac_pool.jpg'), caption: '53m 인피니티풀' },
        { img: require('@/assets/fac_bath.jpg'), caption: '오션뷰 노천탕' },
        { img: require('@/assets/din_cielo.jpg'), caption: '루프탑 바 시엘로' },
      ],
      landscapeActive: 0,
      landscapeTimer: null,
      landscapeItems: [
        { name: '전 객실 오션뷰', desc: '발코니·욕조·주방을 갖춘 전 객실에서 즐기는 동해 파노라마' },
        { name: '53m 인피니티풀', desc: '바다와 이어진 듯한 인피니티풀과 사계절 실내수영장' },
        { name: '스파 & 노천탕', desc: '파도 소리와 함께하는 야외 노천탕과 프리미엄 웰니스 스파' },
        { name: '루프탑 다이닝', desc: '최고층 루프탑 바와 파노라마 라운지에서의 미식' },
        { name: '세계적 서비스', desc: '반얀그룹의 호스피탈리티 DNA를 담은 일상의 품격' },
      ],

      // Q&A
      faqs: [
        { q: '카시아 속초 오너스 멤버십은 어떤 상품인가요?', a: '반얀그룹이 운영하는 5성급 호텔의 특정 객실을 <strong>1/52 지분등기제</strong>로 소유하는 하이엔드 오너스 멤버십입니다. 브랜드가 보증하는 희소성 있는 가치와 혜택을 누리는 공유제 상품으로, 투자수익이 아닌 <strong>사용 가치</strong>에 중점을 둡니다.' },
        { q: '일반 콘도 회원권과 무엇이 다른가요?', a: '콘도 회원권과 달리 특정 객실(전용·공용·주차장 면적 포함)의 1/52 지분을 <strong>소유권 이전(지분 등기)</strong>받는 형태입니다. 보증금 회수가 불가능한 유사 회원권과 차별화된 실질 자산이며, 해당 건물은 생활숙박시설로 분류됩니다.' },
        { q: '회원권 혜택은 어떻게 되나요?', a: '연간 객실 사용(<strong>연 30박</strong>, 회원요금), 조식·디너 뷔페 50% 할인, F&B 20~25% 할인, 인피니티풀·사우나 50% 할인, SPA 20% 할인 등이 제공됩니다.' },
        { q: '평생 연회비 면제가 정말인가요?', a: '최초 가입 이후 <strong>평생 연회비·관리비가 면제</strong>됩니다(증여·명의개서 전까지). 매년 고정비용 없이 프리미엄 멤버십 혜택을 유지하실 수 있습니다.' },
        { q: '20년 만기 후에는 어떻게 되나요?', a: '20년 만기 시 가입 금액을 <strong>100% 전액 안전 회수</strong>하도록 확약합니다. 20년간 객실·부대시설 등 모든 멤버십 혜택을 누리고도 <strong>실질 부담은 0원</strong>인 구조입니다.' },
        { q: '예약은 잘 되나요?', a: '<strong>소수 회원만 모집</strong>하므로 일반 콘도 회원권 대비 예약이 수월할 것으로 기대하셔도 좋습니다. 회원 전용 예약 시스템(앱)도 개발 중입니다.' },
        { q: '미사용 숙박일은 이월되나요?', a: '연간 사용일수는 <strong>매년 3월 1일 리셋</strong>되며, 미사용분은 다음 해로 이월되지 않고 소멸합니다.' },
        { q: '멤버십 카드는 몇 장 발급되나요?', a: '디럭스 1매, 프리미어·시그니처 2매가 발급되며, <strong>카드 1매당 최대 2인</strong>까지 혜택이 제공됩니다. 부대시설 할인은 실물 카드 소지 시 적용됩니다.' },
        { q: '납입 비율은 어떻게 되며, 카드 결제가 가능한가요?', a: '계약 시 계약금(총액의 10%), 계약일로부터 10일 이내 잔금(90%)을 납부합니다. 모든 납부는 <strong>지정된 신탁계좌</strong>로만 가능하며 카드 결제는 불가합니다.' },
        { q: '회원권 양도·매매가 가능한가요?', a: '가능합니다. 양도·매매 시 위탁관리 운영계약상 지위·권리·의무가 <strong>100% 영구 승계</strong>되어 안전하게 거래하실 수 있습니다.' },
        { q: '부동산으로서 가치가 있나요?', a: '등기하여 소유권을 이전받는 형태이므로 <strong>실체적인 실질 자산</strong>이 존재합니다. 다만 본 상품은 투자수익이 아닌 휴양·사용 가치에 중점을 둔 무배당 상품입니다.' },
        { q: '대출(융자)이 가능한가요? 세금은요?', a: '융자는 불가합니다. 취득세 <strong>4.6%</strong> 등 지분 비율에 따른 취득·보유·처분 세금과 분담 의무가 발생합니다.' },
        { q: '상담·계약은 어디서 하나요?', a: '홍보관(<strong>서울 강남구 청담동 124-7</strong>)에서 사전 예약제로 운영됩니다. 현장은 강원 속초시 대포항희망길 120이며, 미리 연락 주시면 대기 없이 상담받으실 수 있습니다.' },
      ],
      faqOpen: [0],
      faqNotes: [
        '상기 Q&A는 이해를 돕기 위한 요약이며, 상세 조건은 홍보관 상담 및 계약서를 통해 안내드립니다.',
        '혜택·할인율·이용 조건 등은 호텔 운영 정책에 따라 변경될 수 있습니다.',
      ],

      // 전경 롤링
      overviewSlides: [
        require('@/assets/ext1.jpg'),
        require('@/assets/ext2.jpg'),
        require('@/assets/ext3.jpg'),
      ],
      activeSlide: 0,
      slideTimer: null,

      // 프리미엄 카드 스크롤 리빌
      premiumIn: [],
      premiumObserver: null,

      // 소개영상
      videoPlaying: false,
    }
  },
  mounted() {
    this.startSlideShow()
    this.startLandscapeShow()
    this.setupPremiumReveal()
  },
  beforeUnmount() {
    this.stopSlideShow()
    this.stopLandscapeShow()
    if (this.premiumObserver) this.premiumObserver.disconnect()
  },
  methods: {
    openRegister() {
      window.dispatchEvent(new Event('open-register-popup'))
    },
    playVideo() {
      this.videoPlaying = true
      this.$nextTick(() => {
        const v = this.$refs.promoVideo
        if (v) {
          v.muted = false
          const p = v.play()
          if (p && p.catch) p.catch(() => {})
        }
      })
    },
    toggleFaq(i) {
      const idx = this.faqOpen.indexOf(i)
      if (idx === -1) this.faqOpen.push(i)
      else this.faqOpen.splice(idx, 1)
    },
    startSlideShow() {
      this.stopSlideShow()
      this.slideTimer = setInterval(() => {
        this.activeSlide = (this.activeSlide + 1) % this.overviewSlides.length
      }, 3800)
    },
    stopSlideShow() {
      if (this.slideTimer) {
        clearInterval(this.slideTimer)
        this.slideTimer = null
      }
    },
    goSlide(i) {
      this.activeSlide = i
      this.startSlideShow()
    },
    startLandscapeShow() {
      this.stopLandscapeShow()
      this.landscapeTimer = setInterval(() => {
        this.landscapeActive = (this.landscapeActive + 1) % this.landscapeSlides.length
      }, 4200)
    },
    stopLandscapeShow() {
      if (this.landscapeTimer) {
        clearInterval(this.landscapeTimer)
        this.landscapeTimer = null
      }
    },
    goLandscape(i) {
      this.landscapeActive = i
      this.startLandscapeShow()
    },
    setupPremiumReveal() {
      const cards = this.$refs.premCards
      if (!cards || !cards.length) return
      if (typeof IntersectionObserver === 'undefined') {
        this.premiumIn = cards.map((_, i) => i)
        return
      }
      this.premiumObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = cards.indexOf(entry.target)
            if (idx !== -1 && !this.premiumIn.includes(idx)) {
              this.premiumIn.push(idx)
            }
            this.premiumObserver.unobserve(entry.target)
          }
        })
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' })
      cards.forEach((el) => this.premiumObserver.observe(el))
    }
  }
}
</script>

<style scoped>
/* ==================== ROOT ==================== */
.lp {
  background: #ffffff;
  color: var(--le-ink);
  font-family: var(--font-sans);
  letter-spacing: -0.01em;
  overflow-x: hidden;
  /* 데스크톱에서도 모바일 폭으로 보이도록 컨테이너 쿼리 기준 설정 */
  container-type: inline-size;
  container-name: lp;
}

.lp em {
  font-family: var(--font-serif-en);
  font-style: italic;
  font-weight: 400;
  color: var(--le-champagne-dark);
}

.lp strong { font-weight: 600; color: var(--le-noir); }

.lp h2,
.lp h3,
.lp p,
.lp dd {
  word-break: keep-all;
  overflow-wrap: break-word;
}

.lp-inner {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 22px;
}
.lp-inner.narrow { max-width: 760px; }
.lp-inner.center { text-align: center; }

.lp-section {
  padding: 96px 0;
  position: relative;
}

.lp-eyebrow {
  display: block;
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.34em;
  font-weight: 600;
  color: var(--le-champagne-dark);
  margin-bottom: 22px;
  text-align: center;
}
.lp-eyebrow.light { color: var(--le-champagne-light); }

.lp-section-title {
  font-family: var(--font-serif-kr);
  font-weight: 300;
  font-size: 32px;
  line-height: 1.45;
  color: var(--le-noir);
  letter-spacing: -0.02em;
  margin-bottom: 28px;
  text-align: center;
}
.lp-section-title em {
  font-family: var(--font-serif-en);
  font-weight: 400;
  font-style: italic;
  color: var(--le-champagne-dark);
}
.lp-section-title.white { color: #ffffff; }
.lp-section-title.white em { color: var(--le-champagne-light); }
.lp-section-title.light { font-weight: 200; }

.lp-gold-line {
  width: 60px; height: 1px;
  background: linear-gradient(90deg, rgba(180,146,78,0), var(--le-champagne), rgba(180,146,78,0));
  margin: 0 auto 40px;
}

.head-lead {
  text-align: center;
  font-family: var(--font-serif-kr);
  font-size: 14.5px;
  font-weight: 300;
  line-height: 1.85;
  color: rgba(10, 28, 51, 0.72);
  margin: 0;
  word-break: keep-all;
}
.head-lead strong { color: var(--le-champagne-dark); font-weight: 600; }

/* ==================== HERO IMAGE ==================== */
.lp-hero-img {
  width: 100%;
  background: #ffffff;
  line-height: 0;
}
.lp-hero-img img {
  display: block;
  width: 100%;
  height: auto;
}
/* ==================== CASSIA FILM (소개영상) ==================== */
.lp-film {
  background: linear-gradient(180deg, #ffffff 0%, var(--le-cream) 100%);
  padding: 84px 0 90px;
}
.lp-film .lp-gold-line { margin-left: auto; margin-right: auto; }
.film-lead {
  font-family: var(--font-serif-kr);
  font-size: 14.5px;
  font-weight: 300;
  line-height: 1.8;
  color: rgba(10, 28, 51, 0.72);
  margin: 0 0 28px;
  word-break: keep-all;
}
.film-lead strong { color: var(--le-champagne-dark); font-weight: 600; }

.film-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 18px;
  overflow: hidden;
  background: var(--le-noir);
  border: 1px solid rgba(10, 28, 51, 0.14);
  box-shadow: 0 22px 48px -28px rgba(10, 28, 51, 0.5);
}
.film-poster {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  display: block;
}
.film-poster img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}
.film-poster::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(10, 28, 51, 0.15) 0%, rgba(10, 28, 51, 0.5) 100%);
  transition: background 0.3s ease;
}
.film-poster:hover img { transform: scale(1.05); }
.film-poster:hover::after { background: linear-gradient(180deg, rgba(10, 28, 51, 0.1) 0%, rgba(10, 28, 51, 0.42) 100%); }
.film-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.94);
  color: var(--le-champagne-dark);
  box-shadow: 0 12px 32px -8px rgba(0, 0, 0, 0.55);
  transition: transform 0.3s ease, background 0.3s ease;
}
.film-play svg { margin-left: 3px; }
.film-poster:hover .film-play {
  transform: translate(-50%, -50%) scale(1.08);
  background: #ffffff;
}
.film-tag {
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 2;
  font-family: var(--font-mono-disp);
  font-size: 10px;
  letter-spacing: 0.34em;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}
.film-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
  display: block;
}

/* ==================== 전경 SLIDER ==================== */
.lp-ovslider {
  width: 100%;
  background: #ffffff;
  padding: 0 0 20px;
}
.ovs-viewport {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: var(--le-noir);
}
.ovs-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1s ease;
  pointer-events: none;
}
.ovs-slide.active {
  opacity: 1;
  pointer-events: auto;
}
.ovs-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.ovs-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 16px 0 4px;
}
.ovs-dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(10, 28, 51, 0.22);
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}
.ovs-dot.active {
  width: 24px;
  background: var(--le-champagne);
}

/* ==================== THE PREMIUM (7) ==================== */
.lp-premium {
  background: linear-gradient(180deg, #ffffff 0%, var(--le-cream) 100%);
  padding: 110px 0 120px;
  position: relative;
}
.lp-premium::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 1px;
  background: linear-gradient(90deg, transparent, var(--le-champagne), transparent);
  opacity: 0.5;
}

.prem-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-top: 20px;
}

.prem-card {
  background: #ffffff;
  border: 1px solid rgba(10, 28, 51, 0.12);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 18px 40px -28px rgba(10, 28, 51, 0.35);
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              box-shadow 0.35s ease, border-color 0.35s ease;
  will-change: opacity, transform;
}
.prem-card.is-in {
  opacity: 1;
  transform: translateY(0);
}
.prem-card-wide {
  grid-column: 1 / -1;
}
.prem-card-wide .prem-fig {
  aspect-ratio: 2 / 1;
}
.prem-card:hover {
  border-color: rgba(180, 146, 78, 0.4);
  box-shadow: 0 26px 50px -26px rgba(10, 28, 51, 0.45);
}

.prem-fig {
  position: relative;
  margin: 0;
  aspect-ratio: 11 / 6;
  overflow: hidden;
  background: var(--le-pearl);
}
.prem-fig img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: scale(1.02);
  transition: transform 0.9s cubic-bezier(0.16, 1, 0.3, 1);
}
.prem-card:hover .prem-fig img {
  transform: scale(1.09);
}
.prem-fig::after {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(180deg, rgba(10, 28, 51, 0) 55%, rgba(10, 28, 51, 0.34) 100%);
  pointer-events: none;
}
.prem-chip {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  display: inline-block;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  font-family: var(--font-rounded);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--le-champagne-dark);
  box-shadow: 0 4px 12px -6px rgba(10, 28, 51, 0.4);
}

.prem-body {
  padding: 16px 15px 20px;
}
.prem-title {
  font-family: var(--font-rounded);
  font-size: 15.5px;
  font-weight: 700;
  color: var(--le-ink);
  letter-spacing: -0.02em;
  line-height: 1.35;
  margin: 0 0 8px;
  word-break: keep-all;
}
.prem-desc {
  font-family: var(--font-sans);
  font-weight: 400;
  font-size: 12.5px;
  line-height: 1.65;
  color: rgba(10, 28, 51, 0.66);
  letter-spacing: -0.01em;
  word-break: keep-all;
  overflow-wrap: break-word;
  margin: 0;
}
.prem-desc :deep(strong) {
  color: var(--le-champagne-dark);
  font-weight: 700;
}

@media (prefers-reduced-motion: reduce) {
  .prem-card { opacity: 1; transform: none; transition: none; }
  .prem-fig img,
  .prem-card:hover .prem-fig img { transform: none; transition: none; }
}

/* ==================== OVERVIEW (사업 개요) ==================== */
.lp-overview-head {
  background: #ffffff;
  padding: 80px 0 36px;
}
.lp-overview {
  background: #ffffff;
  padding: 20px 0 90px;
}
.ov-list {
  margin: 8px 0 0;
  padding: 0;
  border-top: 2px solid var(--le-champagne);
  border-bottom: 1px solid rgba(10, 28, 51, 0.08);
}
.ov-row {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr);
  gap: 14px;
  padding: 18px 4px;
  border-bottom: 1px solid rgba(10, 28, 51, 0.07);
  align-items: start;
}
.ov-row:last-child {
  border-bottom: none;
}
.ov-label {
  font-family: var(--font-rounded);
  font-size: 13px;
  font-weight: 700;
  color: var(--le-champagne-dark);
  letter-spacing: -0.01em;
  line-height: 1.6;
}
.ov-value {
  min-width: 0;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  color: var(--le-ink);
  line-height: 1.6;
  letter-spacing: -0.01em;
  word-break: keep-all;
  margin: 0;
}
.ov-value :deep(.ov-en) {
  display: inline-block;
  margin-left: 6px;
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.14em;
  color: var(--le-warm-grey);
}
.ov-value :deep(.ov-sub) {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.ov-value :deep(.ov-sub + .ov-sub) {
  margin-top: 8px;
}
.ov-value :deep(.ov-tag) {
  flex: 0 0 auto;
  min-width: 44px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--le-pearl);
  color: var(--le-champagne-dark);
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  letter-spacing: -0.01em;
  line-height: 1.5;
}
.ov-value :deep(.ov-txt) {
  flex: 1 1 auto;
  min-width: 0;
  padding-top: 1px;
}
.ov-note {
  margin: 16px 0 0;
  font-family: var(--font-sans);
  font-size: 12px;
  font-weight: 500;
  color: var(--le-warm-grey);
  letter-spacing: -0.01em;
}

/* ==================== LOCATION ==================== */
.lp-location {
  background: #ffffff;
  padding: 90px 0 110px;
}
.loc-lead {
  text-align: center;
  font-family: var(--font-serif-kr);
  font-size: 15px;
  font-weight: 300;
  line-height: 1.7;
  color: var(--le-ink);
  margin: 0 0 34px;
  word-break: keep-all;
}
.loc-lead strong {
  color: var(--le-champagne-dark);
  font-weight: 500;
}
.loc-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}
.loc-item {
  display: flex;
  flex-direction: column;
  padding: 20px 16px 22px;
  background: #ffffff;
  border: 1px solid rgba(10, 28, 51, 0.14);
  border-radius: 16px;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}
.loc-item:hover {
  border-color: rgba(180, 146, 78, 0.45);
  box-shadow: 0 16px 34px -22px rgba(10, 28, 51, 0.4);
  transform: translateY(-2px);
}
.loc-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.loc-num {
  font-family: var(--font-rounded);
  font-size: 12px;
  font-weight: 800;
  color: #ffffff;
  background: linear-gradient(135deg, var(--le-champagne-light), var(--le-champagne-dark));
  padding: 3px 9px;
  border-radius: 999px;
  letter-spacing: 0.02em;
  line-height: 1.5;
}
.loc-en {
  font-family: var(--font-mono-disp);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--le-champagne);
}
.loc-title {
  font-family: var(--font-rounded);
  font-size: 16.5px;
  font-weight: 700;
  color: var(--le-ink);
  margin: 0 0 8px;
  letter-spacing: -0.02em;
  line-height: 1.3;
  word-break: keep-all;
}
.loc-desc {
  font-family: var(--font-sans);
  font-size: 12.5px;
  font-weight: 400;
  line-height: 1.65;
  color: rgba(10, 28, 51, 0.66);
  letter-spacing: -0.01em;
  word-break: keep-all;
  overflow-wrap: break-word;
  margin: 0;
}
.loc-desc :deep(strong) {
  color: var(--le-champagne-dark);
  font-weight: 700;
}
.loc-map {
  margin: 34px 0 0;
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(10, 28, 51, 0.18);
}
.loc-map img {
  display: block;
  width: 100%;
  height: auto;
}

/* ==================== VALUE BAND ==================== */
.lp-value {
  background:
    radial-gradient(ellipse at 50% 0%, rgba(180,146,78,0.16), transparent 60%),
    linear-gradient(180deg, var(--le-noir) 0%, #071324 100%);
  color: #ffffff;
  padding: 100px 0 110px;
}
.value-compare {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: stretch;
  gap: 10px;
  margin-top: 8px;
}
.value-col {
  min-width: 0;
  border-radius: 16px;
  padding: 22px 16px;
  text-align: left;
}
.value-other {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
}
.value-cassia {
  background: linear-gradient(160deg, rgba(180,146,78,0.22), rgba(180,146,78,0.06));
  border: 1px solid rgba(203, 174, 102, 0.55);
}
.value-tag {
  display: block;
  font-family: var(--font-rounded);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255,255,255,0.14);
  word-break: keep-all;
}
.value-other .value-tag { color: rgba(255,255,255,0.7); }
.value-cassia .value-tag { color: var(--le-champagne-light); }
.value-col ul { list-style: none; margin: 0; padding: 0; }
.value-col li {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 14px;
}
.value-col li:last-child { margin-bottom: 0; }
.vc-label {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 500;
  color: rgba(255,255,255,0.55);
  letter-spacing: -0.01em;
}
.vc-strike {
  font-family: var(--font-rounded);
  font-size: 16px;
  font-weight: 700;
  color: rgba(255,255,255,0.85);
  text-decoration: line-through;
  text-decoration-color: rgba(255,120,120,0.9);
  text-decoration-thickness: 2px;
}
.vc-strong {
  font-family: var(--font-rounded);
  font-size: 22px;
  font-weight: 800;
  color: var(--le-champagne-light);
  letter-spacing: -0.02em;
}
.value-vs {
  align-self: center;
  font-family: var(--font-mono-disp);
  font-size: 15px;
  font-weight: 800;
  color: var(--le-champagne-light);
  letter-spacing: 0.02em;
}
.value-guarantees {
  list-style: none;
  margin: 24px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.value-guarantees li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 16px;
  border-radius: 12px;
  background: rgba(180, 146, 78, 0.1);
  border: 1px solid rgba(203, 174, 102, 0.4);
  text-align: left;
}
.vg-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--le-champagne-light), var(--le-champagne-dark));
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}
.vg-text {
  font-family: var(--font-sans);
  font-size: 13.5px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.86);
  letter-spacing: -0.01em;
  word-break: keep-all;
}
.vg-text strong { color: var(--le-champagne-light); font-weight: 700; }

.value-foot {
  margin: 28px 0 0;
  font-family: var(--font-serif-kr);
  font-size: 15px;
  font-weight: 300;
  line-height: 1.9;
  color: rgba(255,255,255,0.9);
  word-break: keep-all;
}
.value-foot strong { color: var(--le-champagne-light); font-weight: 700; }
.value-note {
  margin: 18px 0 0;
  font-size: 11px;
  color: rgba(255,255,255,0.4);
  letter-spacing: -0.01em;
}

/* ==================== OWNERSHIP OFFER ==================== */
.lp-offer {
  background: linear-gradient(180deg, #ffffff 0%, var(--le-cream) 100%);
  padding: 100px 0 110px;
}
.lp-offer .lp-gold-line { margin-left: auto; margin-right: auto; }
.offer-lead {
  font-family: var(--font-serif-kr);
  font-size: 15px;
  font-weight: 300;
  line-height: 1.75;
  color: var(--le-ink);
  margin: 0 0 32px;
  word-break: keep-all;
}
.offer-lead strong { color: var(--le-champagne-dark); font-weight: 500; }

.offer-pillars {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  text-align: left;
}
.offer-pillar {
  position: relative;
  padding: 20px 18px 22px;
  background: #ffffff;
  border: 1px solid rgba(10, 28, 51, 0.12);
  border-radius: 16px;
  box-shadow: 0 16px 36px -28px rgba(10, 28, 51, 0.4);
  overflow: hidden;
}
.offer-pillar::before {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, var(--le-champagne-light), var(--le-champagne-dark));
}
.op-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.op-no {
  font-family: var(--font-mono-disp);
  font-size: 13px;
  font-weight: 800;
  color: #ffffff;
  background: linear-gradient(135deg, var(--le-champagne-light), var(--le-champagne-dark));
  padding: 3px 10px;
  border-radius: 999px;
  letter-spacing: 0.04em;
}
.op-en {
  font-family: var(--font-mono-disp);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: var(--le-champagne);
}
.op-title {
  font-family: var(--font-rounded);
  font-size: 18px;
  font-weight: 800;
  color: var(--le-ink);
  letter-spacing: -0.02em;
  margin: 0 0 8px;
  word-break: keep-all;
}
.op-desc {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.7;
  color: rgba(10, 28, 51, 0.68);
  letter-spacing: -0.01em;
  word-break: keep-all;
  margin: 0;
}
.op-desc :deep(strong) { color: var(--le-champagne-dark); font-weight: 700; }

.offer-specs {
  margin: 20px 0 0;
  padding: 0;
  border-top: 2px solid var(--le-champagne);
  border-bottom: 1px solid rgba(10, 28, 51, 0.08);
  text-align: left;
}
.offer-spec {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 14px;
  padding: 14px 4px;
  border-bottom: 1px solid rgba(10, 28, 51, 0.07);
  align-items: baseline;
}
.offer-spec:last-child { border-bottom: none; }
.offer-spec dt {
  font-family: var(--font-rounded);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--le-champagne-dark);
  letter-spacing: -0.01em;
}
.offer-spec dd {
  min-width: 0;
  margin: 0;
  font-family: var(--font-sans);
  font-size: 13.5px;
  font-weight: 500;
  color: var(--le-ink);
  letter-spacing: -0.01em;
  word-break: keep-all;
}
.offer-spec dd :deep(strong) { color: var(--le-champagne-dark); font-weight: 700; }

.offer-trust {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 22px;
}
.offer-trust-item {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 600;
  color: var(--le-champagne-dark);
  background: var(--le-pearl);
  border: 1px solid rgba(180, 146, 78, 0.3);
  padding: 6px 12px;
  border-radius: 999px;
  letter-spacing: -0.01em;
}
.offer-trust-item::before { content: '✓ '; color: var(--le-champagne); font-weight: 800; }

/* ==================== MEMBERSHIP ==================== */
.lp-mem {
  background: linear-gradient(180deg, var(--le-cream) 0%, #ffffff 100%);
  padding: 110px 0 120px;
}
.mem-headline {
  text-align: center;
  font-family: var(--font-rounded);
  font-size: 19px;
  font-weight: 700;
  color: var(--le-ink);
  letter-spacing: -0.02em;
  margin: 4px 0 24px;
  word-break: keep-all;
}
.mem-headline strong { color: var(--le-champagne-dark); font-weight: 800; }

.mem-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  margin-top: 10px;
}
.mem-card {
  background: #ffffff;
  border: 1px solid rgba(10, 28, 51, 0.14);
  border-radius: 16px;
  padding: 22px 18px 20px;
  box-shadow: 0 18px 40px -30px rgba(10, 28, 51, 0.4);
}
.mem-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(10, 28, 51, 0.1);
}
.mem-card-type {
  font-family: var(--font-rounded);
  font-size: 16px;
  font-weight: 800;
  color: var(--le-ink);
  letter-spacing: -0.02em;
}
.mem-card-total {
  flex-shrink: 0;
  font-family: var(--font-rounded);
  font-size: 13px;
  font-weight: 800;
  color: #ffffff;
  background: linear-gradient(135deg, var(--le-champagne-light), var(--le-champagne-dark));
  padding: 4px 12px;
  border-radius: 999px;
}
.mem-breakdown { list-style: none; margin: 0; padding: 0; }
.mem-breakdown li {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 9px 0;
  border-bottom: 1px dashed rgba(10, 28, 51, 0.1);
}
.mem-breakdown li:last-child { border-bottom: none; }
.mem-b-name {
  font-family: var(--font-sans);
  font-size: 12.5px;
  font-weight: 600;
  color: var(--le-champagne-dark);
  letter-spacing: -0.01em;
}
.mem-b-val {
  font-family: var(--font-sans);
  font-size: 12.5px;
  font-weight: 500;
  color: rgba(10, 28, 51, 0.62);
  letter-spacing: -0.01em;
}
.mem-benefits {
  list-style: none;
  margin: 16px 0 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.mem-benefit {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 15px 15px;
  background: #ffffff;
  border: 1px solid rgba(10, 28, 51, 0.1);
  border-radius: 12px;
}
.mem-benefit-name {
  font-family: var(--font-sans);
  font-size: 11.5px;
  font-weight: 500;
  color: var(--le-warm-grey);
  letter-spacing: -0.01em;
  word-break: keep-all;
}
.mem-benefit-val {
  font-family: var(--font-rounded);
  font-size: 14px;
  font-weight: 700;
  color: var(--le-ink);
  letter-spacing: -0.01em;
  word-break: keep-all;
}
.mem-benefit-val :deep(strong) { color: var(--le-champagne-dark); font-weight: 800; }

/* 유의사항 (shared) */
.comm-notes {
  margin-top: 34px;
  padding-top: 22px;
  border-top: 1px solid rgba(10, 28, 51, 0.12);
}
.comm-notes p {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.6;
  color: var(--le-warm-grey);
  letter-spacing: -0.01em;
  margin: 0 0 5px;
  word-break: keep-all;
}

/* ==================== OCEAN VIEW SHOWCASE ==================== */
.lp-ocean {
  background: var(--le-pearl);
  padding: 110px 0;
}
.lp-ocean .lp-gold-line { margin-left: auto; margin-right: auto; }
.ocean-lead {
  font-family: var(--font-serif-kr);
  font-size: 15px;
  font-weight: 300;
  line-height: 1.75;
  color: var(--le-ink);
  margin: 0 0 30px;
  word-break: keep-all;
}
.ocean-lead strong { color: var(--le-champagne-dark); font-weight: 500; }
.ocean-gallery {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
.ocean-cell {
  position: relative;
  margin: 0;
  border-radius: 16px;
  overflow: hidden;
  aspect-ratio: 4 / 3;
  border: 1px solid rgba(10, 28, 51, 0.14);
  box-shadow: 0 16px 36px -28px rgba(10, 28, 51, 0.4);
}
.ocean-cell-wide {
  grid-column: 1 / -1;
  aspect-ratio: 16 / 9;
}
.ocean-cell img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.9s cubic-bezier(0.16, 1, 0.3, 1);
}
.ocean-cell:hover img { transform: scale(1.05); }
.ocean-cell::after {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(180deg, rgba(10, 28, 51, 0) 55%, rgba(10, 28, 51, 0.34) 100%);
  pointer-events: none;
}
.ocean-cap {
  position: absolute;
  left: 12px;
  bottom: 12px;
  z-index: 2;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(10, 28, 51, 0.5);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  font-family: var(--font-rounded);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #ffffff;
}

/* ==================== ROOM TYPE (legacy, unused) ==================== */
.lp-unit {
  background: var(--le-pearl);
  padding: 110px 0;
}
.lp-unit .lp-gold-line {
  margin-left: auto;
  margin-right: auto;
}
.unit-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  margin: 8px 0 28px;
  padding: 4px 0;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  justify-content: center;
}
.unit-tabs::-webkit-scrollbar { display: none; }

.unit-tab {
  flex-shrink: 0;
  background: #ffffff;
  border: 1px solid rgba(10, 28, 51, 0.3);
  padding: 10px 22px;
  cursor: pointer;
  font-family: var(--font-rounded);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--le-ink);
  border-radius: 999px;
  transition: all 0.25s ease;
}
.unit-tab:hover {
  border-color: var(--le-champagne);
}
.unit-tab.active {
  background: var(--le-champagne);
  border-color: var(--le-champagne);
  color: #ffffff;
  box-shadow: 0 8px 20px -10px rgba(10, 28, 51, 0.5);
}

.unit-panel {
  margin-top: 4px;
  background: #ffffff;
  border: 1px solid rgba(10, 28, 51, 0.14);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 18px 40px -28px rgba(10, 28, 51, 0.35);
  text-align: left;
}
.unit-img-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 7 / 5;
  background: #ffffff;
  overflow: hidden;
}
.unit-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.35s ease;
}
.unit-img.is-loading {
  opacity: 0.3;
}
.unit-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  pointer-events: none;
}
.unit-spinner {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(10, 28, 51, 0.2);
  border-top-color: var(--le-champagne);
  animation: unitSpin 0.8s linear infinite;
}
.unit-loading-label {
  font-family: var(--font-sans);
  font-size: 10px;
  letter-spacing: 0.42em;
  color: var(--le-champagne-dark);
  font-weight: 600;
}
@keyframes unitSpin {
  to { transform: rotate(360deg); }
}
.unit-fade-enter-active,
.unit-fade-leave-active {
  transition: opacity 0.3s ease;
}
.unit-fade-enter-from,
.unit-fade-leave-to {
  opacity: 0;
}

.unit-info {
  padding: 22px 20px 24px;
  border-top: 1px solid rgba(10, 28, 51, 0.1);
}
.unit-info-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(10, 28, 51, 0.1);
}
.unit-info-type {
  font-family: var(--font-rounded);
  font-size: 22px;
  font-weight: 800;
  color: var(--le-ink);
  letter-spacing: -0.02em;
}
.unit-info-count {
  flex-shrink: 0;
  font-family: var(--font-mono-disp);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: var(--le-champagne-dark);
  background: var(--le-pearl);
  padding: 5px 12px;
  border-radius: 999px;
}
.unit-spec {
  margin: 0;
}
.unit-spec-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 2px;
  border-bottom: 1px solid rgba(10, 28, 51, 0.07);
}
.unit-spec-row dt {
  flex-shrink: 0;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  color: var(--le-warm-grey);
  letter-spacing: -0.01em;
}
.unit-spec-row dd {
  margin: 0;
  text-align: right;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  color: var(--le-ink);
  letter-spacing: -0.01em;
}
.unit-spec-total {
  border-bottom: none;
  margin-top: 4px;
  padding-top: 12px;
  border-top: 1.5px solid rgba(10, 28, 51, 0.16);
}
.unit-spec-total dt {
  color: var(--le-champagne-dark);
  font-weight: 700;
}
.unit-spec-total dd {
  color: var(--le-champagne-dark);
  font-weight: 800;
}
.unit-desc {
  margin: 16px 0 0;
  font-family: var(--font-sans);
  font-size: 12.5px;
  line-height: 1.7;
  color: rgba(10, 28, 51, 0.66);
  letter-spacing: -0.01em;
  word-break: keep-all;
}
.unit-note {
  margin: 16px 0 0;
  font-family: var(--font-sans);
  font-size: 11px;
  color: var(--le-warm-grey);
  text-align: center;
  letter-spacing: -0.01em;
}

/* ==================== FACILITY (Dining / Wellness) ==================== */
.lp-facility {
  background: #ffffff;
  padding: 100px 0 110px;
}
.lp-facility-wellness {
  background: linear-gradient(180deg, #ffffff 0%, var(--le-cream) 100%);
}
.fac-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-top: 16px;
}
.fac-card {
  background: #ffffff;
  border: 1px solid rgba(10, 28, 51, 0.12);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 16px 36px -28px rgba(10, 28, 51, 0.35);
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}
.fac-card:hover {
  border-color: rgba(180, 146, 78, 0.4);
  box-shadow: 0 24px 46px -26px rgba(10, 28, 51, 0.45);
  transform: translateY(-2px);
}
.fac-fig {
  position: relative;
  margin: 0;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: var(--le-pearl);
}
.fac-fig img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.9s cubic-bezier(0.16, 1, 0.3, 1);
}
.fac-card:hover .fac-fig img { transform: scale(1.07); }
.fac-fig::after {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(180deg, rgba(10, 28, 51, 0) 55%, rgba(10, 28, 51, 0.32) 100%);
  pointer-events: none;
}
.fac-floor {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  font-family: var(--font-mono-disp);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #ffffff;
  background: rgba(10, 28, 51, 0.55);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  padding: 4px 10px;
  border-radius: 999px;
}
.fac-body {
  padding: 15px 15px 18px;
}
.fac-name {
  font-family: var(--font-rounded);
  font-size: 15px;
  font-weight: 700;
  color: var(--le-ink);
  letter-spacing: -0.02em;
  margin: 0 0 7px;
  word-break: keep-all;
}
.fac-desc {
  font-family: var(--font-sans);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(10, 28, 51, 0.64);
  letter-spacing: -0.01em;
  word-break: keep-all;
  margin: 0;
}

/* ==================== EXPERIENCE (Gallery slider) ==================== */
.lp-landscape {
  background: linear-gradient(180deg, var(--le-cream) 0%, #ffffff 100%);
  padding: 110px 0 120px;
}
.land-lead {
  font-family: var(--font-serif-kr);
  font-size: 15px;
  font-weight: 300;
  line-height: 1.75;
  color: var(--le-ink);
  margin: 0 0 30px;
  word-break: keep-all;
}
.land-lead strong {
  color: var(--le-champagne-dark);
  font-weight: 500;
}
.land-slider {
  margin: 0 0 26px;
}
.land-viewport {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 18px;
  border: 1px solid rgba(10, 28, 51, 0.14);
  background: var(--le-noir);
  box-shadow: 0 18px 40px -28px rgba(10, 28, 51, 0.4);
}
.land-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1s ease;
  pointer-events: none;
}
.land-slide.active {
  opacity: 1;
  pointer-events: auto;
}
.land-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.land-caption {
  position: absolute;
  left: 14px;
  bottom: 14px;
  z-index: 2;
  display: inline-block;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(10, 28, 51, 0.55);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  font-family: var(--font-rounded);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #ffffff;
}
.land-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 16px 0 0;
}
.land-dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(10, 28, 51, 0.22);
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}
.land-dot.active {
  width: 24px;
  background: var(--le-champagne);
}
.land-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  text-align: left;
}
.land-item {
  padding: 16px 15px 18px;
  background: #ffffff;
  border: 1px solid rgba(10, 28, 51, 0.12);
  border-radius: 14px;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}
.land-item:hover {
  border-color: rgba(180, 146, 78, 0.4);
  box-shadow: 0 14px 30px -20px rgba(10, 28, 51, 0.4);
  transform: translateY(-2px);
}
.land-item-name {
  font-family: var(--font-rounded);
  font-size: 15px;
  font-weight: 700;
  color: var(--le-champagne-dark);
  letter-spacing: -0.02em;
  margin: 0 0 7px;
  padding-left: 12px;
  position: relative;
  word-break: keep-all;
}
.land-item-name::before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  bottom: 3px;
  width: 3px;
  border-radius: 3px;
  background: linear-gradient(180deg, var(--le-champagne-light), var(--le-champagne-dark));
}
.land-item-desc {
  font-family: var(--font-sans);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(10, 28, 51, 0.64);
  letter-spacing: -0.01em;
  word-break: keep-all;
  margin: 0;
}

/* ==================== Q & A ==================== */
.lp-faq {
  background: #ffffff;
  padding: 100px 0 110px;
}
.faq-list {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  border-top: 2px solid var(--le-champagne);
}
.faq-item {
  border-bottom: 1px solid rgba(10, 28, 51, 0.1);
}
.faq-q {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 18px 4px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}
.faq-q-mark {
  flex-shrink: 0;
  font-family: var(--font-mono-disp);
  font-size: 14px;
  font-weight: 800;
  color: var(--le-champagne-dark);
  line-height: 1.5;
}
.faq-q-text {
  flex: 1 1 auto;
  font-family: var(--font-rounded);
  font-size: 14px;
  font-weight: 700;
  color: var(--le-ink);
  letter-spacing: -0.02em;
  line-height: 1.5;
  word-break: keep-all;
}
.faq-chevron {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  margin-top: 6px;
  border-right: 2px solid var(--le-champagne-dark);
  border-bottom: 2px solid var(--le-champagne-dark);
  transform: rotate(45deg);
  transition: transform 0.3s ease;
}
.faq-item.open .faq-chevron {
  transform: rotate(-135deg);
  margin-top: 10px;
}
.faq-a-wrap {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.34s cubic-bezier(0.16, 1, 0.3, 1);
}
.faq-item.open .faq-a-wrap {
  grid-template-rows: 1fr;
}
.faq-a {
  overflow: hidden;
}
.faq-a p {
  margin: 0;
  padding: 0 4px 20px 28px;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.75;
  color: rgba(10, 28, 51, 0.68);
  letter-spacing: -0.01em;
  word-break: keep-all;
}
.faq-a p :deep(strong) {
  color: var(--le-champagne-dark);
  font-weight: 700;
}

/* ==================== CTA ==================== */
.lp-cta {
  background:
    radial-gradient(ellipse at 50% 0%, rgba(180,146,78,0.16), transparent 55%),
    linear-gradient(180deg, var(--le-noir) 0%, #071324 100%);
  color: #ffffff;
  padding: 110px 0 130px;
  position: relative;
  overflow: hidden;
}
.lp-cta .lp-inner { position: relative; z-index: 2; }
.lp-cta .lp-gold-line { margin-left: auto; margin-right: auto; }
.cta-desc {
  font-family: var(--font-serif-kr);
  font-weight: 400;
  font-size: 15.5px;
  line-height: 2;
  color: rgba(255,255,255,0.82);
  margin-bottom: 26px;
}
.cta-desc strong {
  color: var(--le-champagne-light);
  font-weight: 600;
}
.cta-points {
  list-style: none;
  margin: 0 auto 34px;
  padding: 0;
  display: inline-flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
}
.cta-point {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cta-point-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--le-champagne-light), var(--le-champagne-dark));
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}
.cta-point-text {
  font-family: var(--font-sans);
  font-size: 14.5px;
  font-weight: 500;
  color: rgba(255,255,255,0.9);
  letter-spacing: -0.01em;
}
.cta-point-text strong {
  color: var(--le-champagne-light);
  font-weight: 700;
}
.cta-btn {
  background: var(--le-champagne);
  border: 1px solid var(--le-champagne);
  color: #ffffff;
  padding: 22px 30px;
  font-family: inherit;
  cursor: pointer;
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  position: relative;
  border-radius: 4px;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
}
.cta-btn::before {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(135deg, var(--le-champagne-dark), var(--le-champagne));
  transform: translateY(101%);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 0;
}
.cta-btn:hover::before { transform: translateY(0); }
.cta-btn > * { position: relative; z-index: 1; }
.cta-btn:hover { color: #ffffff; border-color: var(--le-champagne-light); }
.cta-btn-en {
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.4em;
  color: #ffffff;
  font-weight: 500;
}
.cta-btn-kr {
  font-family: var(--font-serif-kr);
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.cta-btn-arrow {
  font-family: var(--font-serif-en);
  font-size: 18px;
  margin-top: 4px;
  color: #ffffff;
  transition: all 0.4s;
}
.cta-btn:hover .cta-btn-arrow { transform: translateX(4px); }
.cta-note {
  margin-top: 36px;
  font-family: var(--font-serif-kr);
  font-size: 11px;
  color: rgba(255,255,255,0.45);
  line-height: 1.8;
  font-weight: 400;
}

/* ==================== RESPONSIVE (Tablet+) — 컨테이너 기준 ==================== */
@container lp (min-width: 768px) {
  .lp-inner { padding: 0 40px; }
  .lp-section { padding: 130px 0; }

  .lp-section-title { font-size: 44px; margin-bottom: 36px; }
  .lp-eyebrow { font-size: 12px; margin-bottom: 28px; }
  .lp-gold-line { width: 80px; margin-bottom: 56px; }

  .head-lead { font-size: 16px; }

  .prem-grid { grid-template-columns: repeat(2, 1fr); gap: 28px; }
  .prem-body { padding: 26px 24px 30px; }
  .prem-title { font-size: 21px; }
  .prem-desc { font-size: 14px; }

  .loc-lead { font-size: 17px; margin-bottom: 44px; }
  .loc-list { gap: 22px; }
  .loc-item { padding: 30px 28px 32px; }
  .loc-title { font-size: 20px; }
  .loc-desc { font-size: 14px; line-height: 1.75; }

  .value-col { padding: 30px 26px; }
  .vc-strong { font-size: 28px; }
  .value-foot { font-size: 17px; }

  .mem-cards { gap: 22px; }
  .mem-card { padding: 30px 28px 26px; }
  .mem-benefits { grid-template-columns: repeat(3, 1fr); gap: 14px; }

  .fac-grid { grid-template-columns: repeat(3, 1fr); gap: 22px; }
  .fac-name { font-size: 16px; }

  .unit-info { padding: 30px 34px 34px; }
  .unit-info-type { font-size: 26px; }

  .land-lead { font-size: 17px; margin-bottom: 40px; }
  .land-list { grid-template-columns: repeat(3, 1fr); gap: 14px; }
  .land-item { padding: 20px 18px 22px; }
}

@container lp (min-width: 1024px) {
  .lp-section { padding: 160px 0; }
  .lp-section-title { font-size: 52px; }
  .prem-grid { gap: 32px; }
  .loc-list { gap: 26px; }
  .fac-grid { gap: 26px; }

  .unit-panel {
    display: grid;
    grid-template-columns: 1.15fr 0.85fr;
    align-items: stretch;
  }
  .unit-img-wrap { aspect-ratio: auto; border-right: 1px solid rgba(10, 28, 51, 0.1); }
  .unit-info {
    border-top: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
